// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__L4jfB","consentsList":"PatientConsents_consentsList__3kLU2","consentsListEmpty":"PatientConsents_consentsListEmpty__31WMo"};